export default "__VITE_ASSET__BB0d4F6S__"